<template>
    <section class="content">
        <loading :active.sync="isLoading"
        :color="'#39a2db'"
        :loader="'dots'"
        :is-full-page="true"></loading>
        <div class="container-fluid">
            <div class="row">
                <div>
                    <div class="lockscreen-logo">
                        <a href="/soal-mapel"><img src="@/assets/img/logo-tosca.png" alt="logo" width="250"></a>
                    </div>
                    <!-- User name -->
                    <div class="text-center" style="padding: 12px;">
                        <img class="img-bordered-sm" :src="info.img_url" alt="user image" style="width:60%; border-radius:20px;">
                    </div>
                    <br>
                    <br>
                    <div class="text-center">
                        <h6>{{info.display_name}}</h6>
                    </div>
                    <br>
                    <br>
                    <div class="row">
                        <div class="col-2"></div>
                        <div class="col-8">
                            <div class="text-center">
                                <p>Kamu akan segera memulai soal latihan menggunakan e-Learning Taruna. Sistem akan merecord hasil latihan kamu. Silahkan dipersiapkan alat tulis jika diperlukan.
                                    Setelah mulai mengerjakan, maka counter waktu akan terus berjalan dan tidak dapat dihentikan hingga hasil latihan kamu dikirim.
                                    Hasil latihan kamu tetap aman terjaga privasinya, dan akan menjadi bahan evaluasi bagi LBB untuk pengambilan kebijakan di kemudian hari.</p>
                            </div>
                        </div>
                        <div class="col-2"></div>
                    </div>
                    <div class="text-center">
                        <button class="btn btn-lg btn-primary" :disabled="isLoading || recent.canStart === undefined" @click="startTest"><i class="fas fa-arrow-right"></i> Mulai </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { authFetch, auth } from "@/libs/hxcore";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
    export default {
    name: 'SoalStart',
    data() {
        return {
            kode: '',
            info: {
                display_name: 'No Name'
            },
            recent : [],
            isLoading: true,
            type: '',
        };
    },
    created: function () {
        let id = this.$route.params.id;
        let type = this.$route.params.program ? this.$route.params.program : '';
        this.kode = id;
        this.type = type;
        this.loadHasil(id);
        var info = auth.user();
        if(info)this.info = info;
    },
    components: {
        Loading
    },
    methods: {
        redirectToProcess() {
            if (this.recent.mapel_id == 40) {
                this.$router.push("/ujian-process-simbol/" + this.kode);
            } else if (this.recent.is_psikotes) {
                this.$router.push("/ujian-process-kecermatan/"+"0/"+ this.kode);
            } else {
                this.$router.push("/ujian-process/" + this.kode);
            }
        },
        loadHasil(id){
            this.isLoading = true;
            authFetch("/siswa/test/start/" + id).then((res) => {
                res.json().then((json) => {
                    if(json.success) {
                        this.recent = json;
                    }
                    this.isLoading = false;
                });
            });
        },
        startTest: function() {
            this.isLoading = true;
            if (this.recent.canStart) {
                authFetch('/siswa/test/start', {
                        method: 'POST',
                        body: 'kode='+this.kode
                    })
                    .then(res => {
                        if (res.status === 201) {

                        } else if (res.status === 400) {}
                        return res.json();
                    })
                    .then(json => {
                        this.isLoading = false;
                        if(json.success)
                        {
                            if (this.recent.mapel_id == 40) {
                                sessionStorage.removeItem('soals');
                                sessionStorage.removeItem('soal_saat_ini');
                                sessionStorage.removeItem('jawaban');
                                this.$router.push("/ujian-process-simbol/" + this.kode);
                            } else if (this.recent.is_psikotes) {
                                sessionStorage.removeItem('soals');
                                sessionStorage.removeItem('soal_saat_ini');
                                sessionStorage.removeItem('jawaban');
                                this.$router.push("/ujian-process-kecermatan/"+"0/"+ this.kode);
                            } else {
                                this.$router.push("/ujian-process/" + this.kode);
                            }
                        }
                    });
            } else {
                if(!this.recent.expired) {
                    this.isLoading = false;
                    if(this.recent.data && this.recent.data.finished_on) {
                        this.$router.push("/ujian-finish/" + this.kode);
                    } else {
                        this.redirectToProcess();
                    }
                } else {
                    authFetch('/siswa/test/start', {
                            method: 'POST',
                            body: 'kode='+this.kode
                        })
                        .then(res => {
                            if (res.status === 201) {

                            } else if (res.status === 400) {}
                            return res.json();
                        })
                        .then(json => {
                            this.isLoading = false;
                            if(json.success)
                            {
                                this.redirectToProcess();
                            }
                        });
                }
            }
        }
    }
}
</script>
<style type="text/css" scoped>
    .img-bordered-sm {
        width: 100%;
        padding: 25px;
        border: none;
        box-shadow: 0 0.75rem 1.5rem rgb(18 38 63 / 6%);
    }
</style>